/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PersonDto } from './PersonDto';
import {
    PersonDtoFromJSON,
    PersonDtoFromJSONTyped,
    PersonDtoToJSON,
    PersonDtoToJSONTyped,
} from './PersonDto';
import type { StoredFileIdResponse } from './StoredFileIdResponse';
import {
    StoredFileIdResponseFromJSON,
    StoredFileIdResponseFromJSONTyped,
    StoredFileIdResponseToJSON,
    StoredFileIdResponseToJSONTyped,
} from './StoredFileIdResponse';

/**
 * 
 * @export
 * @interface GetPersonByIDResponse
 */
export interface GetPersonByIDResponse {
    /**
     * 
     * @type {PersonDto}
     * @memberof GetPersonByIDResponse
     */
    person: PersonDto;
    /**
     * 
     * @type {Array<StoredFileIdResponse>}
     * @memberof GetPersonByIDResponse
     */
    documents?: Array<StoredFileIdResponse>;
    /**
     * Documents of members indexed by personneId (only for legal entities)
     * @type {{ [key: string]: Array<StoredFileIdResponse>; }}
     * @memberof GetPersonByIDResponse
     */
    collaboratorDocuments?: { [key: string]: Array<StoredFileIdResponse>; };
}

/**
 * Check if a given object implements the GetPersonByIDResponse interface.
 */
export function instanceOfGetPersonByIDResponse(value: object): value is GetPersonByIDResponse {
    if (!('person' in value) || value['person'] === undefined) return false;
    return true;
}

export function GetPersonByIDResponseFromJSON(json: any): GetPersonByIDResponse {
    return GetPersonByIDResponseFromJSONTyped(json, false);
}

export function GetPersonByIDResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPersonByIDResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'person': PersonDtoFromJSON(json['person']),
        'documents': json['documents'] == null ? undefined : ((json['documents'] as Array<any>).map(StoredFileIdResponseFromJSON)),
        'collaboratorDocuments': json['collaboratorDocuments'] == null ? undefined : json['collaboratorDocuments'],
    };
}

export function GetPersonByIDResponseToJSON(json: any): GetPersonByIDResponse {
    return GetPersonByIDResponseToJSONTyped(json, false);
}

export function GetPersonByIDResponseToJSONTyped(value?: GetPersonByIDResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'person': PersonDtoToJSON(value['person']),
        'documents': value['documents'] == null ? undefined : ((value['documents'] as Array<any>).map(StoredFileIdResponseToJSON)),
        'collaboratorDocuments': value['collaboratorDocuments'],
    };
}

